import req from './../../../../fetch';
import { undocumentedResponse } from './../../../../utils';
import { AllAPIResponses, CarbonError } from './../../../../index';

type Params = {
  id: number;
  key: string;
};

type Payload = {
  channelName: string;
  nodeId: number;
  parentNodeId?: number;
  timestamp?: string;
  value: any;
};
const put = async (
  params: Params,
  payload: Payload
): Promise<AllAPIResponses<{}>> => {
  const resp = await req.put(
    `/api/lambdas/${params.id}/test`,
    JSON.stringify(payload)
  );

  try {
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return {
          data: {},
          response: clone,
        };
      case 304:
        return {
          error: new Error('Not modified'),
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};
export default put;
